/**
 * 配列の出現順を保持したままグルーピングする。
 *
 * `Object.entries(groupBy(...))` / `Object.keys(groupBy(...))` はキーが数字のみの場合に
 * 数値風キーとして昇順へ並べ替えられてしまう（ECMAScript 仕様）。`Map` は挿入順を保持する
 * ため、BE が返したソート順（金額順など）をそのまま維持できる。
 *
 * @param items グルーピング対象の配列（並び順を保持したいもの）
 * @param keyFn 各要素からグルーピングキーを取り出す関数
 * @returns キーの初出順を維持した `[key, items]` のタプル配列
 */
export const groupInOrder = <T>(
  items: T[],
  keyFn: (item: T) => string,
): [string, T[]][] => {
  const map = new Map<string, T[]>();
  for (const item of items) {
    const key = keyFn(item);
    const bucket = map.get(key);
    if (bucket) {
      bucket.push(item);
      continue;
    }
    map.set(key, [item]);
  }
  return [...map.entries()];
};
